import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { trpc } from '@/main'
import { IntegrationListPending, IntegrationSettingsRoutePending } from './-components/settings/account-pending'
import { noop } from '@tanstack/react-query'

// `$appId` is a layout: each management section (settings/applicants/companies/jobs) is its own child route, listed
// in the Settings sidebar. The credential prefetch lives here so every child shares it (TanStack runs every matched
// route's loader).
export const Route = createFileRoute('/_app/account/integrations/$appId')({
  context: ({ params }) => ({ appQueryOptions: trpc.apps.getOne.queryOptions(params.appId) }),
  loader: ({ context }) => {
    context.queryClient.query(context.appQueryOptions).catch(noop)
  },
  component: RouteComponent,
  pendingComponent: AppDetailPending,
})

/** The page under it, while this layout's data loads: its settings, or one of its lists. */
function AppDetailPending() {
  const pathname = useLocation({ select: (location) => location.pathname })
  const list = ['applicants', 'companies', 'jobs'].some((entity) => pathname.includes(`/${entity}`))
  return list ? <IntegrationListPending /> : <IntegrationSettingsRoutePending />
}

// Each page brings its own heading: the settings cards theirs, and the lists theirs (integration-list.tsx).
function RouteComponent() {
  return <Outlet />
}
